module.exports = require('./helpers/bundle-url').getBundleURL('hdhZv') + "teak-dune-fluted-kimberly-0.ba176879.jpg";